export const BANOBAGI_LAYOUT = "Banobagi";
const BANOBAGI_LAYOUT_ALIASES = new Set([
  BANOBAGI_LAYOUT.toLowerCase(),
  "banobagi-theme"
]);

export function isBanobagiLayout(value) {
  return (
    typeof value === "string" &&
    BANOBAGI_LAYOUT_ALIASES.has(value.trim().toLowerCase())
  );
}
